module.exports = __webpack_public_path__ + "img/brava-tigre.d54e30d7.jpg";